export const Stages = {
    FIRST: 'firstStageEditor',
    SECOND: 'secondStageEditor'
}
export const FieldPoints = {
    FIELD: 'points',
    ZONE: 'zone'
}

export const FieldMarkingHintsConstant = {
    DEFAULT: `Сейчас вы находитесь в режиме просмотра видео.Для того чтобы перейти к ручной разметке поля необходимо совершить следующие действия (2 этапа):

Этап №1:
    1. Перейдите в режим редактирования (кликните на кнопку «режим редактирования»)

    2. Укажите длину и ширину поля в сантиметрах (внесите значения в поля «ширина» и «высота» с помощью клавиатуры)

    3. Разметьте область поля (установите 4 точки на поле при помощи кликов мышки)

    * переход ко второму этапу произойдет автоматически после того, как предыдущие действия будут сделаны – вам станет доступна кнопка режим редактирования 2 этапа

Этап №2:
    1. Разметьте зону ответственности камеры на видео (необходимо указать от 3 до 8 точек зоны ответственности камеры). По умолчанию для области, которую вы укажите главной (основной) будет считаться камера на видео. Поэтому указывать нужно ту часть поля, к которой камера ближе всего.

    2. Нажмите кнопку отправить (данные сохранятся и можно будет перейти к режиму конфликтной разметки треков).`,
    FIRST_STAGE: `Сейчас вы находитесь на первом этапе ручной разметки. Здесь необходимо выполнить следующие действия:

    1. Укажите длину и ширину поля в сантиметрах (внесите значения в поля «ширина» и «высота» с помощью клавиатуры)

    2. Разметьте область поля (установите 4 точки на поле при помощи кликов мышки)

    После того как вы выполните действия, указанные выше, вы сможете перейти к второму этапу разметки и указать зоны ответственности камеры.`,
    SECOND_STAGE: `Сейчас вы находитесь на втором этапе ручной разметки. Здесь необходимо выполнить следующие действия:

    1. Разметьте зону ответственности камеры на видео (необходимо указать от 3 до 8 точек зоны ответственности камеры). По умолчанию для области, которую вы укажите главной (основной) будет считаться камера на видео. Поэтому указывать нужно ту часть поля, к которой камера ближе всего.

    2. Нажмите кнопку отправить (данные сохранятся и можно будет перейти к режиму конфликтной разметки треков).`
}
